<template>
  <div class="search-item-result">
    <a :href="item.link" class="search-item-result__link">
      <div class="search-item-result__img-wrapper">
        <v-picture :image="item.picture" class="search-item-result__img" />
      </div>
      <div class="search-item-result__text-content">
        <p class="search-item-result__name">{{ item.name }}</p>
        <span class="search-item-result__price">{{ formattedPrice }} ₽</span>
      </div>
    </a>
  </div>
</template>

<script>
import vPicture from '@/components/v-picture.vue';
import formatPrice from '../../../../assets/js/helpers/formatPrice';

export default {
  name: 'search-item-result',

  components: {
    vPicture,
  },

  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    priceToRubles() {
      const rubles = Math.floor(this.item.price / 100);
      const kopecks = this.item.price % 100;
      return +`${rubles}.${kopecks}`;
    },
    formattedPrice() {
      return formatPrice(this.priceToRubles);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-item-result {

  &__link {
    display: flex;
    align-items: center;

    &:hover,
    &:active,
    &:focus-visible {
      & .search-item-result__name {
        color: #E30613;
      }
    }
  }

  &__img-wrapper {
    min-width: 64px;
    width: 64px;
    height: 64px;
    margin-right: 16px;
    overflow: hidden;
  }

  &__img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;

    ::v-deep img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  &__text-content {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    width: 100%;
    overflow: hidden;
  }

  &__name {
    overflow: hidden;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #333332;
    white-space: nowrap;
    text-overflow: ellipsis;

    @media (max-width: 950px) {
      inline-size: 100%;
    }

    @media (max-width: 768px) {
      inline-size: calc(100% - 15px);
    }
  }

  &__price {
    font-weight: 700;
    font-size: 16px;
    line-height: 18px;
    color: #333332;
  }
}
</style>
